<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [title]="'Add Workflow'"
    [canGoBack]="true" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  @if (windowService.isDesktopRes) {
    <tidy-loading-bar class="js-tidy-loading" />
  }
  <tidy-wrapper>

    <tidy-row [align]="'center'">
      <tidy-text
        [body]="'What kind of workflow would you like to add?'" />
    </tidy-row>

    <tidy-card>
      <tidy-card-button (action)="goToAddCustomWorkflowPage()">
        <ion-row>
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/img/workflow-complexity.svg'"
              style="width:40px" />
          </tidy-row>
          <ion-col>
            <tidy-row>
              <tidy-text
                [header]="'Custom Workflow'" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'Trigger workflows based on any event.'"/>
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'Example: When a job is completed, prepare an invoice in a particular format.'"/>
            </tidy-row>
          </ion-col>
        </ion-row>
      </tidy-card-button>
    </tidy-card>

    <tidy-card>
      <tidy-card-button (action)="goToAutomaticBookingPage()">
        <ion-row>
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/img/automatic-booking.svg'"
              style="width:40px" />
          </tidy-row>
          <ion-col>
            <tidy-row>
              <tidy-text
                [header]="'Auto-Schedule Workflow'" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'Automatically create job requests in between guests/tenants to get a turnover done.'"/>
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'Example: Schedule a cleaning after a guest checks out before the next one checks in.'"/>
            </tidy-row>
          </ion-col>
        </ion-row>
      </tidy-card-button>
    </tidy-card>
    
  </tidy-wrapper>
</ng-template>

@if (!windowService.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
